import gql from "graphql-tag";

export default gql`
  query accountGroups($shopId: ID!, $first: ConnectionLimitInt, $after: ConnectionCursor) {
    groups(shopId: $shopId, first: $first, after: $after) {
      nodes {
        _id
        name
        slug
        permissions
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
